import styled from 'styled-components';

export const TagsOverflowContainer = styled.div<{ maxHeight: string }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  max-height: ${(props) => props.maxHeight};
  overflow: auto;
`;

export const TagsWrapper = styled.div<{ tagsAlignment: 'left' | 'right' }>`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  flex: 1;
  justify-content: ${(props) =>
    props.tagsAlignment === 'left' ? 'flex-start' : 'flex-end'};
  min-width: 0;
`;
